import Tooltip from '../../shared/Tooltip';

const VerificationOverlay = ({ verificationOverlay, setVerificationOverlay }) => {
  if (!verificationOverlay.show) return null;

  const handleClose = () => {
    setVerificationOverlay({ ...verificationOverlay, show: false });
  };

  // Get validation data from the overlay
  const validationData = verificationOverlay.validationData || [];
  const hasValidationData = validationData.length > 0;

  // Format date for display
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(parseInt(timestamp)).toLocaleDateString();
  };

  return (
    <>
      {/* Background Overlay for Verification Tooltip */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-40"
        onClick={handleClose}
      />
      
      {/* Verification Tooltip Card */}
      <div 
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-4 max-w-md w-full shadow-lg border border-gray-200 z-50"
      >
        
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-semibold text-gray-900 font-heading">
              Validation Details
            </h4>
            <div className="flex items-center gap-1">
              {/* PDF Attachment Link */}
              <Tooltip text="Attachment available on MYST">
                <div className="flex items-center gap-1 p-1 rounded">
                  <svg className="w-3 h-3 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                  </svg>
                </div>
              </Tooltip>
              
              {/* Close Button */}
              <button
                onClick={handleClose}
                className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded hover:bg-gray-100"
                title="Close"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          
          <div>
            <p className="text-xs text-gray-600 font-roboto-flex mb-1">
              <span className="font-roboto-flex text-gray-800">Title:</span>
            </p>
            <p className="text-xs text-gray-700 font-roboto-flex leading-tight">
              {verificationOverlay.title}
            </p>
          </div>

          {hasValidationData ? (
            <div className="space-y-3">
              <h5 className="text-sm font-semibold text-gray-900 font-heading">Validation Requests</h5>
              {validationData.map((validation, index) => (
                <div key={validation.id || index} className="bg-gray-50 rounded p-3 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-roboto-flex text-gray-800">{validation.keyName}</span>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div>
                      <span className="font-roboto-flex text-gray-600">Validator:</span>
                      <p className="text-gray-600 font-roboto-flex">{validation.validatorName}</p>
                    </div>
                    <div>
                      <span className="font-roboto-flex text-gray-600">Email:</span>
                      <p className="text-gray-600 font-roboto-flex">{validation.validatorEmail}</p>
                    </div>
                    <div>
                      <span className="font-roboto-flex text-gray-600">Relationship:</span>
                      <p className="text-gray-600 font-roboto-flex">{validation.relationship}</p>
                    </div>
                    <div>
                      <span className="font-roboto-flex text-gray-600">Status:</span>
                      <p className="text-gray-600 font-roboto-flex">{validation.status || ''}</p>
                    </div>
                  </div>
                  
                  {validation.remarks && (
                    <div>
                      <span className="text-xs font-roboto-flex text-gray-600">Remarks:</span>
                      <p className="text-xs text-gray-700 mt-1 font-roboto-flex">{validation.remarks}</p>
                    </div>
                  )}
                  
                  {validation.description && (
                    <div>
                      <span className="text-xs font-roboto-flex text-gray-600">Description:</span>
                      <p className="text-xs text-gray-600 mt-1 font-roboto-flex">{validation.description}</p>
                    </div>
                  )}
                  
                  <div className="text-xs text-gray-500">
                    <span className="font-roboto-flex">Date Sent: {formatDate(validation.dateSent)} </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <p className="text-sm text-gray-500 font-roboto-flex">No validation data available</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VerificationOverlay;
